import React, { useEffect, useState, useCallback } from "react";

import { useParams, useHistory, Link as ReactLink } from "react-router-dom";
import Swal from "sweetalert2";

import {
  Flex,
  Link,
  useDisclosure,
  SimpleGrid,
  Text,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";

import CadastrarEquipeModal from "./Cadastrar";
import Group from "./Group";
import Table from "./Table";

import FamiliaAcolhedoraSAService from "../../../../main/services/FamiliaAcolhedoraSAService";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import { format } from "date-fns";
import { cpf } from "../../../utils/masks";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { IconeDownload } from "../../../components/IconeDownload";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";

const FamiliaAcolhedoraServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();

  const { roleKeycloack, user } = useAuthProvider();
  const {
    isOpen: isOpenCadastro,
    onOpen: onOpenCadastro,
    onClose: onCloseCadastro,
  } = useDisclosure();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const [dataSA, setDataSA] = useState();

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.nome;
        let nameB = rowB.original.nome;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return (
          <Text whiteSpace="nowrap">
            {props.value ? cpf(`${props.value}`) : ""}
          </Text>
        );
      },
    },
    {
      Header: "Data de Nascimento",
      accessor: "dataNascimento",
      Cell: (props) => {
        const formattedDate = props.value
          ? format(props.value, "dd/MM/yyyy")
          : "";
        return <Text>{formattedDate}</Text>;
      },
    },
    {
      Header: "Gênero",
      accessor: "genero",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.genero.genero;
        let nameB = rowB.original.genero.genero;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value.genero}</Text>;
      },
    },
    {
      Header: "Bairro",
      accessor: "bairro",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.bairro.nomeBairro;
        let nameB = rowB.original.bairro.nomeBairro;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value.nomeBairro}</Text>;
      },
    },
    {
      Header: "Crianças/Adolescentes acolhidos",
      accessor: (row) => {
        return row;
      },
      sortType: (rowA, rowB, columnId) => {
        const nomesA = rowA?.values[columnId]?.criancas
          ?.map((c) => c?.nome?.toLowerCase() || "")
          .join(", ");

        const nomesB = rowB?.values[columnId]?.criancas
          ?.map((c) => c?.nome?.toLowerCase() || "")
          .join(", ");

        return nomesA?.localeCompare(nomesB);
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          return (roleKeycloack &&
            roleKeycloack.includes(criancaFunc.visualizar)) ||
            roleKeycloack.includes(
              servicoAcolhimentoFunc.visualizarPartePPCAAM
            ) ? (
            <React.Fragment key={index}>
              <Link
                wordBreak={"break-all"}
                title={crianca?.nome}
                as={ReactLink}
                to={
                  "/crianca/" +
                  crianca.id +
                  `?origem=familia-acolhedora&servicoId=${id}`
                }
              >
                <span style={{ whiteSpace: "nowrap" }}>{crianca.nome}</span>
              </Link>
              {props.value.criancas.length > 1 && crianca.nome !== null ? (
                <hr />
              ) : (
                ""
              )}

              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          ) : (
            <React.Fragment key={index}>
              <span style={{ whiteSpace: "nowrap" }}>{crianca.nome}</span>
              {props.value.criancas.length > 1 && crianca.nome !== null ? (
                <hr />
              ) : (
                ""
              )}

              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Validade do termo de Guarda",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          const formattedDate = crianca.dataValidateTermoGuarda
            ? format(crianca.dataValidateTermoGuarda, "dd/MM/yyyy")
            : "";

          return (
            <React.Fragment key={index}>
              {props.value.criancas.length > 1 &&
              crianca.dataValidateTermoGuarda !== null ? (
                <>
                  <span style={{ whiteSpace: "nowrap" }}>{formattedDate}</span>{" "}
                  <hr />
                </>
              ) : props.value.criancas.length === 1 &&
                crianca.dataValidateTermoGuarda !== null ? (
                <span style={{ whiteSpace: "nowrap" }}>{formattedDate}</span>
              ) : (
                <br />
              )}
              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Termo de Guarda",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          return (
            <React.Fragment key={index}>
              {props.value.criancas.length > 1 &&
              crianca.termoGuarda === true ? (
                <>
                  <Flex mb={1} justifyContent={"center"}>
                    <button
                      onClick={() =>
                        getTermoGuarda(id, props.value.cpf, crianca.id)
                      }
                    >
                      <IconeDownload />
                    </button>{" "}
                  </Flex>{" "}
                  <hr />{" "}
                </>
              ) : props.value.criancas.length === 1 &&
                crianca.termoGuarda === true ? (
                <Flex justifyContent={"center"} paddingTop="4">
                  <button
                    onClick={() =>
                      getTermoGuarda(id, props.value.cpf, crianca.id)
                    }
                  >
                    <IconeDownload />
                  </button>{" "}
                </Flex>
              ) : (
                <br />
              )}

              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
  ];

  const getTermoGuarda = (idServicoAcolhimento, cpfFormated, idCrianca) => {
    FamiliaAcolhedoraSAService.getFamiliaAcolhedoraTermoGuarda(
      idServicoAcolhimento,
      cpfFormated,
      idCrianca
    )
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleGetFamiliasAcolhedoras = useCallback(() => {
    setLoading(true);
    FamiliaAcolhedoraSAService.getFamiliasAcolhedorasSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
        if (res.data && res.data.length === 1) {
          history.push(
            `/servico-acolhimento/visualizar-familia-acolhedora/${id}`
          );
        }
      })
      .catch((erro) => {
        setLoading(false);
        setData([]);
      });
  }, [id, history, setLoading, setData]);

  useEffect(() => {
    handleGetFamiliasAcolhedoras();

    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
        if (res.data.tipoServicoAcolhimento.regime === "SAI") {
          Swal.fire({
            title: "Atenção!",
            text: "Este Serviço de Acolhimento não pode acessar essa informação!",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            history.push(`/servico-acolhimento/${id}`);
          });
        }
      })
      .catch((error) => console.log(error));
  }, [history, id, handleGetFamiliasAcolhedoras]);

  const handleCloseCadastroModal = () => {
    handleGetFamiliasAcolhedoras();
    onCloseCadastro();
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicoAcolhimentoFunc.visualizarAcolhedora) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    !loading ? (
      <>
        {(data ? data.length > 0 : false) ? (
          <Flex
            flexDir="column"
            bgColor="#FFF"
            mt="25px"
            borderRadius="16px"
            py="15px"
            px="25px"
          >
            <Group title="Acolhedores" mt="10">
              <Table data={data} columns={columns} />
            </Group>
          </Flex>
        ) : (
          <Flex
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            bgColor="#FFF"
            borderRadius="16px"
            h="250px"
            mt="25px"
          >
            <Text textAlign={"center"} fontSize={["xl", "2xl"]}>
              Não há registros disponíveis
            </Text>
          </Flex>
        )}
        {isOpenCadastro && (
          <CadastrarEquipeModal
            isOpen={isOpenCadastro}
            onOpen={onOpenCadastro}
            onClose={handleCloseCadastroModal}
          />
        )}
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        ></SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default FamiliaAcolhedoraServicoAcolhimento;
